module.exports = {
	"cs-CZ": "Členové:",
	"en-GB": "Members:",
	"fr-FR": "Membres:",
	"de-DE": "Mitgliede:"
};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Members.json
// module id = 81
// module chunks = 0